import React from 'react';
import { useUnit } from 'effector-react';
import {
  $kgPoints,
  $scPoints,
  $stPoints,
  $fc_ssPoints,
  $gcPoints,
  $hosPoints,
  $conPoints,
  $faPoints,
  $polPoints,
} from '../../models/absoluteModel/index.js';
import AbsolutePointsPreset from '../Layers/AbsolutePointsPreset.jsx';

function AbsoluteLayersManager() {
  const kgPoints = useUnit($kgPoints);
  const scPoints = useUnit($scPoints);
  const stPoints = useUnit($stPoints);
  const fc_ssPoints = useUnit($fc_ssPoints);
  const gcPoints = useUnit($gcPoints);
  const hosPoints = useUnit($hosPoints);
  const polPoints = useUnit($polPoints);
  const conPoints = useUnit($conPoints);
  const faPoints = useUnit($faPoints);

  const pointsList = [
    { name: 'kg', points: kgPoints, color: '#A1C3D1' },
    { name: 'sc', points: scPoints, color: '#F7B2AD' },
    { name: 'st', points: stPoints, color: '#FFD972' },
    { name: 'fc_ss', points: fc_ssPoints, color: '#B5EAD7' },
    { name: 'gc', points: gcPoints, color: '#E2F0CB' },
    { name: 'hos', points: hosPoints, color: '#CBAACB' },
    { name: 'pol', points: polPoints, color: '#FFB7B2' },
    { name: 'con', points: conPoints, color: '#D5AAFF' },
    { name: 'fa', points: faPoints, color: '#B5B9FF' },
  ];
  return (
    <>
      {pointsList.map(({ name, points, color }) => (
        <AbsolutePointsPreset
          key={name}
          name={name}
          points={points}
          color={color}
        />
      ))}
    </>
  );
}

export default AbsoluteLayersManager;
